<div *ngIf="isLoading" class="overlay">
  <div class="spinner"></div>
</div>
I
<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row justify-content-center">
      <!-- <div class="col-3 col-md-2" *ngFor="let card of resumenCards; index as i">
              <div
                class="card card-stats"
                [ngClass]="{ 'card-stats__selected': i === 3 }"
                [routerLink]="card.route"
                [style.cursor]="card.route ? 'pointer' : 'default'"
              >
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-md-6 col-lg-5">
                      <div
                        class="icon-big text-center text-dark rounded shadow"
                        [ngClass]="card.bgClass"
                      >
                        <i [class]="card.icon"></i>
                      </div>
                    </div>
                    <div class="col-7 d-flex flex-column justify-content-center">
                      <p class="card-category mb-0">{{ card.label }}</p>
                      <h4
                        class="card-title mb-0"
                        [ngClass]="{ 'text-dark': i === 3, 'text-white': i !== 3 }"
                      >
                        {{ card.value }}
                      </h4>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="stats">
                    <small [class]="i == 3 ? 'desc__selected' : 'desc'">{{
                      card.desc
                    }}</small>
                  </div>
                </div>
              </div>
            </div> -->
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header card-header-icon d-flex align-items-center">
            <div class="card-icon">
              <i class="material-icons">perm_identity</i>
            </div>
            <h4 class="card-title mb-0 me-3 flex-grow-1">
              {{ id ? "Update" : "New" }} vendor
            </h4>
            <div class="ms-auto">
              <i
                class="fas fa-edit text-dark icon__edit"
                (click)="enableUpdate()"
              ></i>
            </div>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <!-- Información Básica -->
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="displayName"
                      >displayName</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="displayName"
                      formControlName="displayName"
                      [readOnly]="!update"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('displayName')"
                    >
                      displayName is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <div
                    class="form-group d-flex justify-content-center align-items-center gap-4"
                  >
                    <div class="custom-control custom-switch mt-4 checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="status"
                        formControlName="status"
                      />
                      <label class="custom-control-label" for="status"
                        >Active</label
                      >
                    </div>
                  </div>
                </div>
              </div>
              <button
                type="submit"
                class="btn btn-dark pull-right btn-create d-flex m-auto"
                [disabled]="form.invalid"
              >
                {{ id ? "Update" : "Create" }}
              </button>
              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
